import {chevronLeftSvg as Icon__small__chevronLeftSvg} from '../Icon__small/Icon__small--chevronLeft.js';
import {chevronLeftSvg as Icon__xsmall__chevronLeftSvg} from '../Icon__xsmall/Icon__xsmall--chevronLeft.js';
import {chevronLeftSvg as Icon__xxsmall__chevronLeftSvg} from '../Icon__xxsmall/Icon__xxsmall--chevronLeft.js';

export var chevronLeft = {
  name: 'chevronLeft',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chevronLeftSvg,
  alt: {
    Icon__small: Icon__small__chevronLeftSvg,
    Icon__xsmall: Icon__xsmall__chevronLeftSvg,
    Icon__xxsmall: Icon__xxsmall__chevronLeftSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
